import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  makeStyles,
  TextField,
} from "@material-ui/core";
import { UserDataContext } from "../Contexts/UserDataContext";

const useStyles = makeStyles((theme) => ({
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  feedback: {
    maxHeight: "160px",
  },
}));

const MfaDialog = (props) => {
  const { onClose, open, ...rest } = props;
  const { userData, verifyMfa } = useContext(UserDataContext);
  const [mfaKey, setMfaKey] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const handleSubmit = async () => {
    setLoading(true);
    await verifyMfa(mfaKey, setErrorMessage);
    setLoading(false);
  };

  return (
    <Dialog open={Boolean(userData.mfaRequired)} {...rest}>
      <DialogTitle>Multifactor Authentication</DialogTitle>
      <Divider />

      <DialogContent>
        <DialogContentText>
          Please enter the code that was sent to your email address.
        </DialogContentText>
        <TextField
          autoFocus
          value={mfaKey}
          onChange={(event) => setMfaKey(event.target.value)}
          fullWidth
          placeholder="Enter code"
          disabled={loading}
        />
      </DialogContent>

      {errorMessage !== "" ? (
        <Box border={1} borderRadius={4} borderColor={"error.main"}>
          <DialogContent className={classes.feedback}>
            <DialogContentText>{errorMessage}</DialogContentText>
          </DialogContent>
        </Box>
      ) : (
        <Divider />
      )}

      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MfaDialog;
